import React from "react";
import {
  Button
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {getImage} from "../../utils/image";
import {Link} from "react-router-dom";

const ActivationSmallCard = ({ imageId, name, slug }) => {
  const classes = useStyles();
  return (
    <Button className={classes.card} component={Link} to={`/services/${slug}`}>
      <div className={classes.cardImage}>
        <img src={getImage(imageId, {width: 48, height: 48})}/>
      </div>
      <div className={classes.cardName}>{name || ''}</div>
      {/*<div className={classes.cardPrice}>от 25.88 ₽</div>*/}
    </Button>
  )
}

const useStyles = makeStyles((theme) => ({
  card: {
    width: "100%",
    padding: "6px",
    boxShadow: "none",
    borderRadius: "12px",
    alignItems: "initial",
    flexDirection: "column",
    border: "1px solid rgba(255,255,255,0.1)",
    backgroundColor: "#243239",

    "&:hover,&:focus,&:active": {
      backgroundColor: "#243239",
    }
  },
  cardImage: {
    width: "48px",
    height: "48px",
    display: "flex",
    margin: "0 auto",
    marginTop: "2px",
    marginBottom: "6px",
    overflow: "hidden",
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",

    "& img": {
      width: "100%",
      height: "100%",
      display: "block",
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
      objectPosition: "center center",
    },
  },
  cardName: {
    fontSize: 16,
    opacity: "0.8",
    fontWeight: "500",
    lineHeight: "20px",
    overflow: "hidden",
    textAlign: "center",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: theme.palette.text.primary,
  },
  cardPrice: {
    height: "28px",
    display: "flex",
    marginTop: "6px",
    borderRadius: "8px",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FB780026",

    fontSize: 13,
    fontWeight: "500",
    lineHeight: "16px",
    color: theme.palette.text.primary,
  },
}));

export default ActivationSmallCard
